import estornar from '@/core/store/adesao/itens-adesao/estorno/estornar'
import historico from '@/core/store/adesao/itens-adesao/estorno/historico'

export default {
	modules: {
		estornar,
		historico,
	},
}
